export const ConsumerServices = {
  "label": "Consumer Services",
  "value": [
    {
      "code": "DD-1500",
      "keyword": "Consumer Complaints"
    },
    {
      "code": "DD-2100.1000",
      "keyword": "Better Business Bureaus"
    },
    {
      "code": "DF-4500.1000",
      "keyword": "Business Registration\/Licensing"
    },
    {
      "code": "DF-4500.2000-130",
      "keyword": "Child Care Provider Licensing"
    },
    {
      "code": "DF-8000.4500",
      "keyword": "Labor Standards and Practices"
    },
    {
      "code": "DM-1500.1500",
      "keyword": "Credit Counseling"
    },
    {
      "code": "DM-1500.1640",
      "keyword": "Credit Reporting Agencies"
    },
    {
      "code": "DM-1800.1000",
      "keyword": "Bankruptcy Assistance"
    },
    {
      "code": "DM-1800.5000",
      "keyword": "Mortgage Delinquency and Default Counseling"
    },
    {
      "code": "DM-6500",
      "keyword": "Personal Financial Counseling"
    },
    {
      "code": "DM-7000",
      "keyword": "Representative Payee Services"
    },
    {
      "code": "DT-8400.8700",
      "keyword": "Taxpayer Advocate Services"
    },
    {
      "code": "DT-8800",
      "keyword": "Tax Preparation Assistance"
    }
  ]
}
